export const STAR_RATING_KEY = 'starRatings[]';
export const DEFAULT_MEDIA_COUNTS = 20;
export const DEFAULT_FEATURE_COUNTS = 10;
